
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    text: {
      required: true,
      type: String
    },
    subtitle: {
      required: false,
      type: String,
      default: ''
    }
  }
});
